import Wrapper from './Wrapper';
import {useHelpContext} from './Provider';

const HelpWrapper = Wrapper;
export default HelpWrapper;

export {
    useHelpContext as useHelp,
}